// extracted by mini-css-extract-plugin
module.exports = {"form":"divisionManagement_form__2WK2Z"};